import EmployeeForm from "./EmployeeForm"
import EmployeeList from "./EmployeeList"

let App=()=>{
    return(
        <div>
            <EmployeeForm/>
            <EmployeeList/>
        </div>
    )
}
export default App